import authorization from 'live/services/authorization'

// auth for load plugin on live menu
export const hasPermission =
    authorization.superAdmin ||
    authorization.Permission.AEAPPS_RESOURCES_MANAGER_ADMIN ||
    authorization.Permission.AEAPPS_RESOURCES_MANAGER_MANAGER ||
    authorization.Permission.AEAPPS_RESOURCES_MANAGER_USER

export const hasAdminPermission = authorization.superAdmin || authorization.Permission.AEAPPS_RESOURCES_MANAGER_ADMIN

export const hasManagerPermission = authorization.Permission.AEAPPS_RESOURCES_MANAGER_MANAGER

export const hasUserPermission = authorization.Permission.AEAPPS_RESOURCES_MANAGER_USER
